module.exports = __webpack_public_path__ + "img/districomoil.30af6bed.jpg";